import { ResourcePage } from "@/components/resource-page"
import { z } from "zod"
import { Puzzle } from "lucide-react"

const pluginSchema = z.object({
  name: z.string().min(1, "Name is required"),
  display_name: z.string().min(1, "Display name is required"),
  version: z.string().optional(),
  description: z.string().optional(),
  author: z.string().optional(),
})

const pluginColumns = [
  { key: "id", type: "text", options: { label: "ID" } },
  { key: "name", type: "text", options: { label: "Name" } },
  { key: "display_name", type: "text", options: { label: "Display Name" } },
  { key: "version", type: "text", options: { label: "Version" } },
  { key: "description", type: "text", options: { label: "Description" } },
  { key: "author", type: "text", options: { label: "Author" } },
  { key: "is_enabled", type: "boolean", options: { label: "Enabled" } },
  { key: "installed_at", type: "date", options: { label: "Installed" } },
]

const pluginFormFields = [
  { name: "name", label: "Name", type: "text", placeholder: "Enter plugin name" },
  { name: "display_name", label: "Display Name", type: "text", placeholder: "Enter display name" },
  { name: "version", label: "Version", type: "text", placeholder: "Enter version" },
  { name: "description", label: "Description", type: "text", placeholder: "Enter description" },
  { name: "author", label: "Author", type: "text", placeholder: "Enter author" },
]

export default function PluginsPage() {
  return (
    <ResourcePage
      resource="plugins"
      title="Plugins"
      icon={Puzzle}
      columns={pluginColumns}
      formFields={pluginFormFields}
      formSchema={pluginSchema}
      searchPlaceholder="Search plugins..."
    />
  )
}
